<template>
  <div>
    <input class="input-file-cover" type="file" ref="file" name="file" @change="loadImage($event)" accept="image/png, image/gif, image/jpeg" />

    <b-btn @click="openFileChooser" class="mr-3">
      {{ chooseBtn }}
    </b-btn>

    <b-btn @click="crop()" :disabled="image.src === null" class="mr-3" variant="success">
      {{ sendBtn }}
    </b-btn>

    <cropper
      class="cropper mt-3"
      ref="cropper"
      v-if="cover === null"
      :src="image.src"
      :canvas="{
        minWidth: 0,
        minHeight: 0,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
	    }"
      :stencil-props="{
        aspectRatio: aspectRatio,
      }"
    />

    <div class="mt-3 text-center">
      <b-img v-if="cover !== ''" :src="cover"></b-img>
    </div>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

export default {
  name: "ImageUpload",
  props: ['maxWidth', 'maxHeight', 'aspectRatio', 'chooseBtn', 'sendBtn'],
  componets: {
    Cropper,
  },
  data() {
    return {
      cover: null,
      image: {
        src: null,
        type: null,
      },
    };
  },
  methods: {
    async openFileChooser () {
      if (this.cover === null) {
        this.$refs.file.click()
        return
      }

      const action = await this.$bvModal.msgBoxConfirm('A imagem atual será substituída. Deseja continuar?', {
        title: '⚠ Atenção',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não ',
        centered: true,
        hideHeaderClose: false
      })

      if (action === false || !action) {
        return false
      }

      this.$refs.file.click()
      this.cover = null
    },
    async crop() {
      const { canvas } = this.$refs.cropper.getResult();
      if (!canvas) {
        return
      }

      let blob = await new Promise(resolve => canvas.toBlob(resolve, this.image.type))
      let path = await this.uploadImage(blob)
      if (path === '') {
        return
      }

      this.reset()
      this.cover = path
      this.$emit('uploadDone', {
        image: path
      })
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      // Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },
    async uploadImage(blob) {
      const form = new FormData()
      const url = process.env.VUE_APP_URL_APP + '/b/upload'
      const baseUrl = process.env.VUE_APP_URL_WEB
      const options = { emulateJSON: true }
      form.append("file", blob)
      try {
        let resp = await this.$http.post(url, form, options)
        return baseUrl + resp.body.path
      } catch (e) {
        console.error(e)
        return ""
      }
    },
  },
	destroyed() {
		// Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
		if (this.image.src) {
			URL.revokeObjectURL(this.image.src)
		}
	}
};
</script>

<style scoped>
.input-file-cover {
  display: none;
}
</style>
